module.exports = __webpack_public_path__ + "img/NTS-B.c7b98c9f.png";